import { defineStore } from 'pinia'
import AppProfile from '~/components/AppProfile.vue'

export const useModalProfileStore = defineStore('modal', () => {
  const toast = useToast()
  const modal = useModal()
  const isOpen = computed(() => modal.isOpen)

  const openModal = () => {
    modal.open(AppProfile, {
      onClose() {
        modal.close()
      },
      onSuccess({ description }) {
        toast.add({
          title: 'Sukses!',
          description,
          id: 'modal-profile-success',
          timeout: 2000,
          color: 'green'
        })
      }
    })
  }

  return { openModal, isOpen }
})
